import { render, staticRenderFns } from "./printerRuleList.vue?vue&type=template&id=332a01a2&scoped=true"
import script from "./printerRuleList.vue?vue&type=script&lang=js"
export * from "./printerRuleList.vue?vue&type=script&lang=js"
import style0 from "./printerRuleList.vue?vue&type=style&index=0&id=332a01a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332a01a2",
  null
  
)

export default component.exports